










import {
    Component,
    Prop,
    Vue,
} from 'vue-property-decorator';
import responsive from './responsive';

@Component({})
export default class DescriptionList extends Vue {
    @Prop({
        type: String,
        default: '',
    })
    private title!: string;

    @Prop({
        type: String,
        default: 'small',
    })
    private size!: string;

    @Prop({
        type: Object,
        default() {
            return {};
        },
    })
    private gutter!: any;

    @Prop({
        type: Object,
        default() {
            return {};
        },
    })
    private restProps!: any;

}
